import { RegXUtils, TOKEN } from '@/utils'
import { ProductViewModel } from '@/view-models'
import { ProductHTTP } from '@/http'
import {
  ServerConfigModalView,
  DomainSelectionModalView,
  CustomFieldModalView,
  CustomFieldView
} from '@/views'
import { GroupViewModel } from '../view-models/group.view-model'
import { ProductButtonView } from '../views/product-button.view'
import { PricingTableView } from '../views/pricing-table.view'
import { GroupButtonView } from '../views/group-button.view'
import { PricingTableModalView } from '../views/pricing-table.modal'
import { CartModalManager } from '../views/cart-modal.manager'

export const setupProductOffer = (): void => {
  const cartProductOffers = document.querySelectorAll<HTMLElement>(
    '.js-cart-product-offer'
  )

  const productHttp = new ProductHTTP(new RegXUtils())
  const productViewModel = new ProductViewModel(productHttp)
  const groupViewModel = new GroupViewModel(productHttp)

  cartProductOffers.forEach((offerWidget) => {
    if (!TOKEN) {
      throw new Error("Product Offer Setup: Token isn't set")
    }

    const serverConfigModal =
      offerWidget.querySelector<HTMLElement>('.js-server-config')
    if (!serverConfigModal) {
      throw new Error('Product Offer: server config modal el is missing')
    }
    const serverConfigModalView = new ServerConfigModalView(serverConfigModal)

    const domainSelectionModal = offerWidget.querySelector<HTMLElement>(
      '.js-domain-selection'
    )
    if (!domainSelectionModal) {
      throw new Error('Product Offer: domain selection modal el is missing')
    }
    const domainSelectionModalView = new DomainSelectionModalView(
      domainSelectionModal,
      new RegXUtils()
    )

    const customFieldModal = offerWidget.querySelector<HTMLElement>(
      '.modal.js-custom-fields'
    )
    const customFieldEl = offerWidget.querySelector<HTMLElement>(
      '#custom-fields-view'
    )
    if (!customFieldModal) {
      throw new Error('Product Offer: custom field modal el is missing')
    }
    if (!customFieldEl) {
      throw new Error('Product Offer: custom field wrapper el is missing')
    }
    const customFieldView = new CustomFieldView(customFieldEl, new RegXUtils())
    const customFieldModalView = new CustomFieldModalView(
      customFieldModal,
      customFieldView
    )

    const modalManager = new CartModalManager(
      domainSelectionModalView,
      serverConfigModalView,
      customFieldModalView
    )

    if (groupViewModel.isGroup(offerWidget)) {
      const pricingTableModal = offerWidget.querySelector<HTMLElement>(
        '.js-product-list-modal'
      )
      const pricingTableEl = offerWidget.querySelector<HTMLElement>(
        '.js-product-list-modal .js-pricing-table'
      )

      if (!pricingTableModal) {
        throw new Error('Product Offer: Pricing Table Modal is missing')
      }

      if (!pricingTableEl) {
        throw new Error('Product Offer: Pricing Table is missing')
      }

      const pricingTableModalView = new PricingTableModalView(pricingTableModal)

      modalManager.setPricingTableView(pricingTableModalView)

      new PricingTableView(pricingTableEl, groupViewModel, modalManager, TOKEN)

      new GroupButtonView(offerWidget, modalManager)

      return
    }

    const productModel = productViewModel.makeModel(offerWidget, TOKEN)

    new ProductButtonView(
      productModel,
      offerWidget,
      modalManager,
      productViewModel
    )
  })
}
